module.exports = __webpack_public_path__ + "static/education_sec2_obj2@2x-da10b7f535a3cbff34ca63fa49db5cb2.png";